import React from 'react'
import styled from '@emotion/styled'

import {HorizontalScroll} from '@vio/atlas/helpers/HorizontalScroll'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'
import {cssTheme} from '@vio/atlas/themes'
import {linariaMq} from '@vio/atlas/utils/breakpoints'

const AvailabilityTileSkeleton = styled(SkeletonLoader)`
  min-width: 38%;
  ${linariaMq.mobileLg} {
    min-width: 28%;
  }
`
const ScrollElement = styled(HorizontalScroll)`
  padding-top: ${cssTheme.layout.spacing.s600};
  padding-bottom: ${cssTheme.layout.spacing.s400};
  ${linariaMq.desktopXs} {
    flex-wrap: nowrap;
  }
`

export const Loading = () => {
  return (
    <>
      <SkeletonLoader width={180} marginTop={0} />
      <SkeletonLoader width={190} />
      <ScrollElement rowGap="s300" columnGap="s300">
        <AvailabilityTileSkeleton marginTop={0} />
        <AvailabilityTileSkeleton marginTop={0} />
        <AvailabilityTileSkeleton marginTop={0} />
        <AvailabilityTileSkeleton marginTop={0} />
        <AvailabilityTileSkeleton marginTop={0} />
        <AvailabilityTileSkeleton marginTop={0} />
      </ScrollElement>
    </>
  )
}
